// FOR YOU棚の並び替え(rankForYou)。DOMは触らない純粋関数だけをここに置く。
// 画面制御(閲覧記録の読み取り・カードの差し替えなど)は別の担当がこの下に追記する。
// 設計: SP/research/merch-algo/design.md 4.1章。ES2019まで(テーマの他のJSに合わせる)。
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.ScForYou = factory();
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function cmpId(a, b) {
    var na = Number(a);
    var nb = Number(b);
    if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
    return a < b ? -1 : a > b ? 1 : 0;
  }

  function vendorKeyOf(catalog, id) {
    var v = catalog && catalog.vendors ? catalog.vendors[id] : undefined;
    return v ? v : '__id__' + id;
  }

  // catalog.families(2品以上の家族の配列の配列)からid->印(家族の先頭id)の表を作る。
  // 家族に入っていないidは自分自身が印(=他とかぶらない)。catalogがnull/familiesが無い時は空の表になり、
  // familyMarkOf(id)は常にid自身を返すので、家族の仕組みが無い時と同じ動きになる(2026-09-27 3回目の差し戻し)。
  function buildFamilyMarkMap(catalog) {
    var map = {};
    var families = catalog && catalog.families ? catalog.families : [];
    families.forEach(function (group) {
      var mark = String(group[0]);
      group.forEach(function (id) { map[String(id)] = mark; });
    });
    return map;
  }

  function pickReason(rec) {
    var order = ['pair', 'brand', 'related'];
    var best = order[0];
    var bestVal = -Infinity;
    for (var i = 0; i < order.length; i++) {
      var cat = order[i];
      var v = rec.byCategory[cat] || 0;
      if (v > bestVal) {
        bestVal = v;
        best = cat;
      }
    }
    return best;
  }

  /**
   * 「あなたへの棚」の並び替え(段1: catalogを使う。catalogが無い時は段0にそのまま落ちる)。
   * 純粋関数(DOM・localStorage・通信は一切触らない)。
   * @param {Object} input
   *   state: 'viewed' | 'member'(はじめて状態はこの関数を呼ばない)
   *   viewed: 商品ID配列(新しい順)
   *   cart: 商品ID配列
   *   onPage: 商品ID配列(同じページの新着棚など、既に見えている品)
   *   history: [{id, days}](会員の購入履歴。同じ品は最新のみ・30件まで、を呼び出し側が保証)
   *   related: { [viewedId]: 商品ID配列 }(Shopifyの関連の品、呼び出し側が最大6件に絞る)
   *   catalog: catalog.json相当のオブジェクト、または null
   *   limit: 出力する最大件数(既定12)
   * @returns {{state: string, items: Array<{id: string, reason: string, days?: number}>}}
   *   候補が4件未満なら items は空配列(=差し替えない、の合図)。
   */
  function rankForYou(input) {
    input = input || {};
    var state = input.state;
    var limit = input.limit || 12;
    var catalog = input.catalog || null;
    var viewed = (input.viewed || []).map(String);
    var cart = (input.cart || []).map(String);
    var onPage = (input.onPage || []).map(String);
    var history = input.history || [];
    var relatedMap = input.related || {};

    if (state !== 'viewed' && state !== 'member') {
      return { state: state, items: [] };
    }

    // 家族(箱数・販売元違い等)の印。無い品は自分のidが印になるので、catalogにfamiliesが無くても今と同じ動き。
    var familyMarkMap = buildFamilyMarkMap(catalog);
    function familyMarkOf(id) {
      id = String(id);
      return familyMarkMap[id] !== undefined ? familyMarkMap[id] : id;
    }

    // viewed・cart・onPageの除外、会員historyの除外は、idではなく家族の印で比べる
    // (箱数・販売元違いの言い換えが、見た/カート中/購入済みの品として二重に出ないようにする)。
    var excludeAlways = {};
    viewed.concat(cart, onPage).forEach(function (id) { excludeAlways[familyMarkOf(id)] = true; });
    var historyIds = {};
    history.forEach(function (h) { historyIds[familyMarkOf(String(h.id))] = true; });

    var scoreMap = {}; // id -> { total, byCategory }

    function addScore(id, amount, category) {
      id = String(id);
      if (excludeAlways[familyMarkOf(id)]) return;
      if (state === 'member' && historyIds[familyMarkOf(id)]) return;
      if (!scoreMap[id]) scoreMap[id] = { total: 0, byCategory: {} };
      var rec = scoreMap[id];
      rec.total += amount;
      rec.byCategory[category] = (rec.byCategory[category] || 0) + amount;
    }

    var replenishItems = [];

    if (state === 'viewed') {
      var top3 = viewed.slice(0, 3);
      var weights = [1, 0.7, 0.5];
      top3.forEach(function (vid, idx) {
        var w = weights[idx];
        var pairList = catalog && catalog.pairs && catalog.pairs[vid] ? catalog.pairs[vid] : [];
        pairList.forEach(function (pid, k) { addScore(pid, w * (1 / (k + 1)), 'pair'); });
        if (pairList.length < 3) {
          var relList = (relatedMap[vid] || []).slice(0, 6);
          relList.forEach(function (pid, k) { addScore(pid, 0.6 * w * (1 / (k + 1)), 'related'); });
        }
      });
    } else {
      // member
      history.forEach(function (h) {
        var hid = String(h.id);
        var newness = Math.exp(-Number(h.days) / 180);
        var pairList = catalog && catalog.pairs && catalog.pairs[hid] ? catalog.pairs[hid] : [];
        pairList.forEach(function (pid, k) { addScore(pid, newness * (1 / (k + 1)), 'pair'); });
      });

      if (catalog && catalog.vendors && catalog.trending) {
        var vendorPrefRaw = {};
        history.forEach(function (h) {
          var v = catalog.vendors[String(h.id)];
          if (!v) return;
          var newness = Math.exp(-Number(h.days) / 180);
          vendorPrefRaw[v] = (vendorPrefRaw[v] || 0) + newness;
        });
        var total = 0;
        Object.keys(vendorPrefRaw).forEach(function (k) { total += vendorPrefRaw[k]; });
        if (total > 0) {
          catalog.trending.forEach(function (pid, r) {
            var id = String(pid);
            var v = catalog.vendors[id];
            if (!v || !vendorPrefRaw[v]) return;
            var pref = vendorPrefRaw[v] / total;
            addScore(id, pref * 0.5 * (1 - r / 24), 'brand');
          });
        }
      }

      history.forEach(function (h) {
        var hid = String(h.id);
        var days = Number(h.days);
        var median = 54;
        if (catalog && catalog.windows && catalog.windows[hid]) median = catalog.windows[hid][1];
        var d = median > 0 ? days / median : 0;
        if (d >= 0.75 && d <= 2.0) {
          var sc = 2 + Math.exp(-Math.pow((d - 1) / 0.35, 2));
          replenishItems.push({ id: hid, score: sc, days: days });
        }
      });
    }

    replenishItems.sort(function (a, b) { return (b.score - a.score) || cmpId(a.id, b.id); });

    var organic = Object.keys(scoreMap).map(function (id) {
      return { id: id, score: scoreMap[id].total, reason: pickReason(scoreMap[id]) };
    });
    organic.sort(function (a, b) { return (b.score - a.score) || cmpId(a.id, b.id); });

    var stream = replenishItems.map(function (r) { return { id: r.id, kind: 'replenish', days: r.days }; })
      .concat(organic.map(function (o) { return { id: o.id, kind: o.reason }; }));

    var discoveryPool = state === 'viewed'
      ? ((catalog && catalog.first_time) || [])
      : ((catalog && catalog.trending) || []);
    var fillPoolsRaw = state === 'viewed'
      ? [((catalog && catalog.first_time) || []), ((catalog && catalog.trending) || [])]
      : [((catalog && catalog.trending) || [])];
    var fillStream = [];
    fillPoolsRaw.forEach(function (pool) { pool.forEach(function (pid) { fillStream.push(String(pid)); }); });

    var kept = [];
    var keptFamilies = {}; // idではなく家族の印で「棚に入った」を管理(箱数・販売元違いの二重掲載防止・2026-09-27)
    var vendorCount = {};
    var streamIdx = 0;
    var fillIdx = 0;
    var discoveryDone = false;

    function tryAdd(id, kind, days) {
      id = String(id);
      var fam = familyMarkOf(id);
      if (keptFamilies[fam]) return false;
      if (excludeAlways[fam]) return false;
      if (state === 'member' && historyIds[fam] && kind !== 'replenish') return false;
      if (kind === 'replenish') {
        kept.push({ id: id, reason: 'replenish', days: days });
        keptFamilies[fam] = true;
        return true;
      }
      var vk = vendorKeyOf(catalog, id);
      if ((vendorCount[vk] || 0) >= 2) return false;
      kept.push({ id: id, reason: kind });
      keptFamilies[fam] = true;
      vendorCount[vk] = (vendorCount[vk] || 0) + 1;
      return true;
    }

    while (kept.length < limit) {
      if (!discoveryDone && kept.length === 3) {
        discoveryDone = true;
        var usedVendors = {};
        kept.forEach(function (it) { usedVendors[vendorKeyOf(catalog, it.id)] = true; });
        var picked = null;
        for (var j = 0; j < discoveryPool.length; j++) {
          var did = String(discoveryPool[j]);
          var dfam = familyMarkOf(did);
          if (keptFamilies[dfam] || excludeAlways[dfam]) continue;
          if (state === 'member' && historyIds[dfam]) continue;
          var dvk = vendorKeyOf(catalog, did);
          if (usedVendors[dvk]) continue;
          picked = did;
          break;
        }
        if (picked) {
          kept.push({ id: picked, reason: 'discovery' });
          keptFamilies[familyMarkOf(picked)] = true;
          var pvk = vendorKeyOf(catalog, picked);
          vendorCount[pvk] = (vendorCount[pvk] || 0) + 1;
          continue;
        }
        // 見つからなければ通常の流れへ(下に続く)
      }
      if (streamIdx < stream.length) {
        var cur = stream[streamIdx++];
        tryAdd(cur.id, cur.kind, cur.days);
        continue;
      }
      if (fillIdx < fillStream.length) {
        var fid = fillStream[fillIdx++];
        tryAdd(fid, 'fill');
        continue;
      }
      break;
    }

    if (kept.length < 4) return { state: state, items: [] };

    var items = kept.slice(0, limit).map(function (it) {
      var o = { id: it.id, reason: it.reason };
      if (it.reason === 'replenish') o.days = it.days;
      return o;
    });
    return { state: state, items: items };
  }

  return { rankForYou: rankForYou };
});
// ==== ここまでが rankForYou（純粋関数・DOM操作なし） ====
// 画面制御（DOM操作・localStorageの読み取りなど）は別の担当がこの下に追記する。

// ==== 画面制御（DOM操作・localStorageの読み取りなど）ここから ====
// window/document が無い環境（Node の require 等。merch-rank.test.mjs が rankForYou を読み込む時）では何もしない。
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
(function () {
  'use strict';
  if (window.__scForYouWired) {
    return;
  }
  window.__scForYouWired = true;

  var STORAGE_KEY = 'sleektheme:recently-viewed';
  var SC_TEXT = {
    viewed: {
      heading: 'あなたへのおすすめ',
      description: 'ご覧になった商品と一緒にご購入の多い商品です'
    },
    member: {
      heading: 'あなたへのおすすめ',
      description: 'ご購入の履歴から選んでいます'
    }
  };
  var SC_REC = {
    'for-you': { first: 'home-first', viewed: 'home-viewed', member: 'home-member' },
    'new-arrivals': { first: 'home-new', viewed: 'home-new', member: 'home-new' },
    'limited-sets': { first: 'home-limited', viewed: 'home-limited', member: 'home-limited' }
  };

  function onIdle(fn) {
    try {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(fn);
      } else {
        setTimeout(fn, 1);
      }
    } catch (e) {}
  }

  function readJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return fallback;
    }
  }

  function getViewedIds() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = readJSON(raw, []);
      if (!Array.isArray(list)) return [];
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var n = parseInt(list[i], 10);
        if (!isNaN(n)) out.push(n);
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function wireRecClick(root) {
    try {
      var shelfKind = root.getAttribute('data-sc-shelf');
      var codes = SC_REC[shelfKind];
      if (!codes) return;
      root.addEventListener(
        'click',
        function (evt) {
          try {
            var link = evt.target && evt.target.closest ? evt.target.closest('a[href]') : null;
            if (!link || !root.contains(link)) return;
            var state = root.getAttribute('data-sc-current-state') || root.getAttribute('data-sc-state-default') || 'first';
            var code = codes[state] || codes.first;
            if (!code) return;
            var url = new URL(link.href, window.location.origin);
            url.searchParams.set('sc_rec', code);
            link.href = url.toString();
          } catch (e) {}
        },
        true
      );
    } catch (e) {}
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('bad status');
      return res.json();
    });
  }

  function loadCatalog(root) {
    try {
      var el = document.getElementById('sc-merch-catalog');
      if (el && el.textContent) {
        var parsed = readJSON(el.textContent, null);
        if (parsed) return Promise.resolve(parsed);
      }
    } catch (e) {}
    return Promise.resolve(null);
  }

  function getMemberHistory(root, catalog) {
    try {
      var el = document.getElementById('sc-member-history');
      if (el && el.textContent) {
        var hist = readJSON(el.textContent, []);
        if (Array.isArray(hist) && hist.length) return hist;
      }
    } catch (e) {}
    return null;
  }

  function fetchRelated(ids) {
    var jobs = [];
    for (var i = 0; i < ids.length; i++) {
      (function (id) {
        var url = '/recommendations/products.json?product_id=' + id + '&limit=6&intent=related';
        jobs.push(
          fetchJSON(url)
            .then(function (data) {
              var list = (data && data.products) || [];
              var out = [];
              for (var j = 0; j < list.length; j++) {
                if (list[j] && list[j].id) out.push(list[j].id);
              }
              return { id: id, ids: out };
            })
            .catch(function () {
              return { id: id, ids: [] };
            })
        );
      })(ids[i]);
    }
    return Promise.all(jobs);
  }

  function getCartIds() {
    return fetchJSON('/cart.js')
      .then(function (cart) {
        var out = [];
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i] && items[i].product_id) out.push(items[i].product_id);
        }
        return out;
      })
      .catch(function () {
        return [];
      });
  }

  function getOnPageIds() {
    try {
      var arrivals = document.querySelector('[data-sc-shelf="new-arrivals"] [data-sc-shelf-ids]');
      if (!arrivals) return [];
      var raw = arrivals.getAttribute('data-sc-shelf-ids') || '';
      if (!raw) return [];
      var parts = raw.split(',');
      var out = [];
      for (var i = 0; i < parts.length; i++) {
        var n = parseInt(parts[i], 10);
        if (!isNaN(n)) out.push(n);
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function buildSearchUrl(root, ids) {
    try {
      var base = root.getAttribute('data-sc-search-url');
      var sectionId = root.getAttribute('data-sc-section-id');
      if (!base || !sectionId) return null;
      var terms = [];
      for (var i = 0; i < ids.length; i++) {
        terms.push('id:' + ids[i]);
      }
      return base + '?section_id=' + encodeURIComponent(sectionId) + '&type=product&q=' + encodeURIComponent(terms.join(' OR '));
    } catch (e) {
      return null;
    }
  }

  function countRenderedCards(scope) {
    try {
      return scope.querySelectorAll('[data-sc-product-id]').length;
    } catch (e) {
      return 0;
    }
  }

  function applyReplenishNotes(root, container, items) {
    try {
      var tpl = root.getAttribute('data-sc-days-template');
      if (!tpl || !items) return;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.reason !== 'replenish' || it.days === undefined || it.days === null) continue;
        var card = container.querySelector('[data-sc-product-id="' + it.id + '"]');
        if (!card) continue;
        var titleEl = card.querySelector('.product-card__title');
        if (!titleEl || !titleEl.parentNode) continue;
        var note = document.createElement('p');
        note.className = 'p-scShelf__daysNote';
        note.textContent = tpl.replace('{{ days }}', String(it.days));
        titleEl.parentNode.insertBefore(note, titleEl.nextSibling);
      }
    } catch (e) {}
  }

  function applySwap(root, state, fragmentDoc, items) {
    try {
      var newSlider = fragmentDoc.querySelector('product-slider');
      var oldSlider = root.querySelector('product-slider');
      if (!newSlider || !oldSlider || !oldSlider.parentNode) return false;
      if (countRenderedCards(newSlider) < 4) return false;

      var headingEl = root.querySelector('[data-sc-shelf-heading]');
      var descEl = root.querySelector('[data-sc-shelf-desc]');
      var copy = SC_TEXT[state];
      if (copy) {
        if (headingEl) headingEl.textContent = copy.heading;
        if (descEl) descEl.textContent = copy.description;
      }

      var sc_focus_in_old_slider = oldSlider.contains(document.activeElement);
      oldSlider.parentNode.replaceChild(newSlider, oldSlider);
      applyReplenishNotes(root, newSlider, items);
      root.setAttribute('data-sc-current-state', state);
      if (state === 'member') {
        root.setAttribute('data-clarity-mask', 'true');
      }
      if (sc_focus_in_old_slider && headingEl) {
        headingEl.focus();
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function rankAndRender(root, state, input) {
    try {
      if (!window.ScForYou || !window.ScForYou.rankForYou) return;
      var result = window.ScForYou.rankForYou(input);
      if (!result || !result.items || result.items.length < 4) return;
      var ids = [];
      for (var i = 0; i < result.items.length; i++) {
        ids.push(result.items[i].id);
      }
      var url = buildSearchUrl(root, ids);
      if (!url) return;
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('bad status');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          applySwap(root, state, doc, result.items);
        })
        .catch(function () {});
    } catch (e) {}
  }

  function initForYou(root) {
    try {
      var viewed = getViewedIds();
      var historyEl = document.getElementById('sc-member-history');
      var hasRealHistory = false;
      if (historyEl && historyEl.textContent) {
        var parsedHist = readJSON(historyEl.textContent, []);
        hasRealHistory = Array.isArray(parsedHist) && parsedHist.length > 0;
      }

      var state = 'first';
      if (hasRealHistory) {
        state = 'member';
      } else if (viewed.length) {
        state = 'viewed';
      }
      if (state === 'first') {
        return;
      }

      loadCatalog(root).then(function (catalog) {
        getCartIds().then(function (cart) {
          var onPage = getOnPageIds();

          if (state === 'member') {
            var history = getMemberHistory(root, catalog);
            if (!history || !history.length) {
              return;
            }
            rankAndRender(root, 'member', {
              state: 'member',
              viewed: viewed,
              cart: cart,
              onPage: onPage,
              history: history,
              related: {},
              catalog: catalog,
              limit: 16
            });
            return;
          }

          // viewed
          var top3 = viewed.slice(0, 3);
          var needRelated = [];
          for (var i = 0; i < top3.length; i++) {
            var pairs = catalog && catalog.pairs ? catalog.pairs[top3[i]] : null;
            if (!pairs || pairs.length < 3) {
              needRelated.push(top3[i]);
            }
          }
          var relatedPromise = needRelated.length ? fetchRelated(needRelated) : Promise.resolve([]);
          relatedPromise.then(function (relatedList) {
            var related = {};
            for (var j = 0; j < relatedList.length; j++) {
              related[relatedList[j].id] = relatedList[j].ids;
            }
            rankAndRender(root, 'viewed', {
              state: 'viewed',
              viewed: viewed,
              cart: cart,
              onPage: onPage,
              history: [],
              related: related,
              catalog: catalog,
              limit: 16
            });
          });
        });
      });
    } catch (e) {}
  }

  function boot() {
    try {
      var roots = document.querySelectorAll('[data-sc-shelf-root]');
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        if (root.getAttribute('data-sc-wired') === 'true') continue;
        root.setAttribute('data-sc-wired', 'true');
        wireRecClick(root);
        if (root.getAttribute('data-sc-shelf') === 'for-you') {
          initForYou(root);
        }
      }
    } catch (e) {}
  }

  onIdle(boot);
})();
}
// ==== 画面制御ここまで ====

